import React from 'react'

const DragDotsIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={10}
      height={16}
      fill="none"
      {...props}
    >
      <path fill="#0085FF" d="M3.35 1.852a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0Z" />
      <path
        stroke="#0085FF"
        d="M3.2 1.85a1.35 1.35 0 1 0-2.7 0 1.35 1.35 0 0 0 2.7 0Z"
      />
      <path fill="#0085FF" d="M9.35 1.852a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0Z" />
      <path
        stroke="#0085FF"
        d="M9.2 1.85a1.35 1.35 0 1 0-2.7 0 1.35 1.35 0 0 0 2.7 0Z"
      />
      <path fill="#0085FF" d="M9.35 7.852a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0Z" />
      <path
        stroke="#0085FF"
        d="M9.2 7.85a1.35 1.35 0 1 0-2.7 0 1.35 1.35 0 0 0 2.7 0Z"
      />
      <path
        fill="#0085FF"
        d="M9.35 13.852a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0Z"
      />
      <path
        stroke="#0085FF"
        d="M9.2 13.85a1.35 1.35 0 1 0-2.7 0 1.35 1.35 0 0 0 2.7 0Z"
      />
      <path
        fill="#0085FF"
        d="M3.35 13.852a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0Z"
      />
      <path
        stroke="#0085FF"
        d="M3.2 13.85a1.35 1.35 0 1 0-2.7 0 1.35 1.35 0 0 0 2.7 0Z"
      />
      <path fill="#0085FF" d="M3.35 7.852a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0Z" />
      <path
        stroke="#0085FF"
        d="M3.2 7.85a1.35 1.35 0 1 0-2.7 0 1.35 1.35 0 0 0 2.7 0Z"
      />
    </svg>
  )
}

export default DragDotsIcon
